import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopNav from "../components/Navbars/TopNav";
import Footer from "../components/Navbars/footer";

function ScreenWarning({ onProceed }) {
  return (
    <div className="fixed inset-0 bg-white text-red-500 flex items-center justify-center z-[100] p-4 text-center">
      <div className="max-w-md">
        <p className="text-lg font-bold mb-4">
          Warning! This page is optimized for larger screens. Please use a
          device with a screen width above 799 for the best experience.
        </p>
        <button
          onClick={onProceed}
          className="bg-green-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-green-600 transition-colors"
        >
          Proceed Anyway
        </button>
      </div>
    </div>
  );
}

export default function MainLayout() {
  const location = useLocation();
  const contentRef = React.useRef(null);
  const [showWarning, setShowWarning] = React.useState(false);

  React.useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  React.useEffect(() => {
    const handleResize = () => {
      setShowWarning(window.innerWidth < 800);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProceed = () => {
    setShowWarning(false);
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-50">
      {showWarning && <ScreenWarning onProceed={handleProceed} />}
      <TopNav />
      <div
        ref={contentRef}
        className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden pt-16"
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
